module.exports = ".app {\n  padding: 0;\n  /*\n    .app-header {\n        padding: 10px 0 10px 0;\n\n        .app-header-logo {\n            padding-left: 1em;\n            width: 326px;\n\n            @include breakpoint(sm) {\n                padding: 0;\n            }\n        }\n    }\n    */ }\n  @media (min-width: 768px) {\n    .app {\n      padding: 0 60px 0 60px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main